import { render, staticRenderFns } from "./LogsFiltros.vue?vue&type=template&id=2f8051a4&"
import script from "./LogsFiltros.vue?vue&type=script&lang=js&"
export * from "./LogsFiltros.vue?vue&type=script&lang=js&"
import style0 from "./LogsFiltros.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports